export default __webpack_public_path__ + "static/media/settingsBlack.84f981fe.svg";